import { render } from "./template.vue?vue&type=template&id=71cb530f&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=71cb530f&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cb530f"]])

export default __exports__